import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import AppBarStyled from './AppBarStyled';
import HeaderContent from './HeaderContent';
import LogoIcon from 'components/logo/LogoIcon';
import { BRAND_NAME } from 'config';
import { useGetMenuMaster } from 'api/menu';
import { DRAWER_WIDTH, MINI_DRAWER_WIDTH } from 'config';

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

// Native aspect ratio of the provided shape (viewBox 0 0 539.6 98.7)
const SHAPE_VB_WIDTH = 539.6;
const SHAPE_VB_HEIGHT = 98.7;

export default function Header() {
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  const tabWidth = drawerOpen ? DRAWER_WIDTH + 110 : MINI_DRAWER_WIDTH + 150;
  const tabHeight = 64;

  const appBar = {
    position: 'fixed',
    color: 'inherit',
    elevation: 0,
    sx: {
      borderBottom: '1px solid',
      borderBottomColor: 'divider',
      backgroundColor: '#fff'
    }
  };

  return (
    <AppBarStyled {...appBar}>
      <Toolbar sx={{ minHeight: '64px !important', position: 'relative', pl: 0, overflow: 'visible' }}>
        {/* Shape background — using the provided path, stretched to tabWidth */}
        <Box
          sx={{
            position: 'absolute',
            left: 0,
            top: 0,
            width: tabWidth * 1.5,
            height: tabHeight,
            zIndex: 0,
            transition: 'width 0.2s ease'
          }}
        >
          <svg
            width="100%"
            height="100%"
            viewBox={`0 0 ${SHAPE_VB_WIDTH} ${SHAPE_VB_HEIGHT}`}
            preserveAspectRatio="none"
            style={{ display: 'block' }}
          >
            <defs>
              {/* <linearGradient id="navTabGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#5b6ee8" />
                <stop offset="50%" stopColor="#7c5cd6" />
                <stop offset="100%" stopColor="#9b4fc2" />
              </linearGradient> */}
            </defs>
            <path
              d="M539.1 0H0v98.7h486.4c16.9 0 30.5-13.7 30.5-30.5V33.1c0-14.7 9.5-27.1 22.7-31.4-.2-.6-.3-1.1-.5-1.7z"
              fill="url(#navTabGradient)"
            />
          </svg>
        </Box>

        {/* Text/logo layer */}
        <Box
          sx={{
            position: 'relative',
            zIndex: 1,
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            gap: 2.25,
            pl: -5,
            pr: 5,
            width: 'fit-content',
            whiteSpace: 'nowrap'
          }}
        >
          <Box
            sx={{
              width: 55,
              height: 45,
              borderRadius: '0%',
           
              display: 'grid',
              placeItems: 'center',
              flexShrink: 0
            }}
          >
            <LogoIcon width={32} height={22} />
          </Box>
          <Box sx={{ pl: 1 }}>
            <Typography sx={{ fontSize: '1.2rem', fontWeight: 700, lineHeight: 1.3, color: '#000', whiteSpace: 'nowrap' }}>
              {BRAND_NAME}
            </Typography>
            <Typography sx={{ fontSize: '0.7rem', color: 'rgba(46, 41, 41, 0.75)', lineHeight: 1.2, whiteSpace: 'nowrap' }}>
              Automation Intelligence
            </Typography>
          </Box>
        </Box>

        {/* Spacer so HeaderContent starts after the tab */}
        <Box sx={{ width: tabWidth, flexShrink: 0, transition: 'width 0.2s ease' }} />

        <HeaderContent />
      </Toolbar>
    </AppBarStyled>
  );
}
